/* platform/utils/exportUtils — CSV, Excel, and print-PDF export utilities.
   Uses the `xlsx` package (v0.18.5) already in dependencies. */
import * as XLSX from 'xlsx';

const esc = (v) => {
  const s = (v == null ? '' : String(v)).replace(/"/g, '""');
  return /[",\n]/.test(s) ? `"${s}"` : s;
};

const download = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};

export const exportCSV = (filename, rows, columns) => {
  if (!rows.length) return;
  const cols = columns || Object.keys(rows[0]).filter(k => typeof rows[0][k] !== 'object');
  const csv = [cols.join(','), ...rows.map(r => cols.map(c => esc(r[c])).join(','))].join('\n');
  download(new Blob([csv], { type: 'text/csv' }), filename + '.csv');
};

export const exportExcel = (filename, sheets) => {
  const wb = XLSX.utils.book_new();
  (Array.isArray(sheets) ? sheets : [{ name: 'Data', rows: sheets }]).forEach(({ name, rows, columns }) => {
    const cols = columns || (rows.length ? Object.keys(rows[0]).filter(k => typeof rows[0][k] !== 'object') : []);
    const data = [cols, ...rows.map(r => cols.map(c => r[c] ?? ''))];
    const ws = XLSX.utils.aoa_to_sheet(data);
    ws['!cols'] = cols.map(() => ({ wch: 20 }));
    XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31));
  });
  XLSX.writeFile(wb, filename + '.xlsx');
};

export const exportPDF = (title) => {
  const orig = document.title;
  document.title = title;
  window.print();
  document.title = orig;
};

/* Column presets for each entity type */
export const COLS = {
  organizations: ['name', 'industry', 'country', 'status', 'plan', 'users', 'created'],
  partners:      ['name', 'type', 'status', 'region', 'since'],
  platformUsers: ['name', 'email', 'platformRole', 'status', 'lastLogin', 'createdAt'],
  licenses:      ['type', 'org', 'seats', 'used', 'status', 'renews'],
  audit:         ['action', 'who', 'target', 'category', 'severity', 'time'],
};
